import Vue from 'vue'
import VueRouter from 'vue-router'
import middleware from '../middleware'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'register',
	component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue'),
	meta: {
		middleware: 'guest'
	},
  },
  {
    path: '/inspect',
    name: 'inspect',
	component: () => import(/* webpackChunkName: "inspect" */ '../views/InspectVue.vue'),
	meta: {
		middleware: 'auth'
	},
  },
  {
    path: '/login',
    name: 'login',
	component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue'),
	meta: {
		middleware: 'guest'
	},
  },
  {
	path: '/simulator/f/pf',
    name: 'pf',
	component: () => import(/* webpackChunkName: "pf" */ '../views/SimulatorPF.vue'),
	children: [
		{
			name: 'pf-details',
			path: 'details/:id',
			component: () => import('../views/SimulatorPF/PfDetails.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'pf-create',
			path: 'create',
			component: () => import('../views/SimulatorPF/PfCreate.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'pf-index',
			path: ':help?',
			component: () => import('../views/SimulatorPF/PfHome.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		
	],
	meta: {
		middleware: 'auth'
	},
  },
  {
    path: '/simulator/f/arce',
    name: 'arce',
	component: () => import(/* webpackChunkName: "about" */ '../views/SimulatorTeach.vue'),
	meta: {
		middleware: 'auth'
	},
	children: [
	

		{
			name: 'arce-details-list',
			path: 'list',
			component: () => import('../views/SimulatorTeach/ArceList.vue'),
			meta: {
				middleware: 'auth',
			},
		},

		{
			name: 'arce-clients',
			path: 'clients',
			component: () => import('../views/SimulatorTeach/ArceClients.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'arce-client',
			path: 'clients/:id',
			component: () => import('../views/SimulatorTeach/ArceClient.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		
		{
			name: 'arce-profile-client',
			path: 'clients/profile/:id',
			component: () => import('../views/SimulatorTeach/ArceProfileClient.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'arce-policies-resumen',
			path: 'policies/resumen/:id',
			component: () => import('../views/SimulatorTeach/ArcePoliciesResumen.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'arce-details',
			path: 'details/:id',
			component: () => import('../views/SimulatorTeach/ArceDetails.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'arce-index',
			path: ':help?',
			component: () => import('../views/SimulatorTeach/ArceHome.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'arce-error',
			path: '*',
			redirect: { name: 'formation-index' }
		}
	]
  },
  {
    path: '/formation',
    name: 'formation',
	component: () => import(/* webpackChunkName: "about" */ '../views/Formation.vue'),
	meta: {
		middleware: 'auth'
	},
	children: [
		{
			name: 'formation-activity',
			path: ':module/game/learning/:activity',
			component: () => import('../views/ActivityView.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'formation-evaluation',
			path: ':module/evaluation/:activity',
			component: () => import('../views/EvaluationView.vue'),
			meta: {
				middleware: 'auth',
			},
		},
		{
			name: 'formation-questions',
			path: ':module/questions/:activity',
			component: () => import('../views/QuestionsView.vue'),
			meta: {
				middleware: 'auth',
			},
		},

		{
			path: ':modal?/:activity?',
			name: 'formation-index',
			component: () => import('../views/Formation/FormationIndex.vue'),
			meta: {
				middleware: 'auth',
			},
		},
	]
  },
  
  {
	name: 'error',
	path: '*',
	redirect: { name: 'formation-index' }
}
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	if (to.meta.middleware) {
		const nameMiddleware = Array.isArray(to.meta.middleware)
			? to.meta.middleware
			: [to.meta.middleware]

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = middleware[nextFactory(context, nameMiddleware, 1)] || next
		return middleware[nameMiddleware[0]]({ ...context, next: nextMiddleware })
	}

	return next();
});

function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	if (!subsequentMiddleware) return context.next;
	return (...parameters) => {
	  context.next(...parameters)
	  const nextMiddleware = nextFactory(context, middleware, index + 1)
	  subsequentMiddleware({ ...context, next: nextMiddleware })
	};
}

export default router
